import { AuthStateType, UserType } from "Interfaces"

export const useIsEmployer = (auth: AuthStateType) => {
    
   return auth?.data?.type === UserType.EMPLOYER
}
